import { useRef, useState } from "react"
import { DOWNLOAD_TYPES, INPUTS } from "hooks/budgeting/useDownloadBudgetConfig"

export const usePdfOptions = ({ downloadBudgetConfig }) => {
  const tipo = DOWNLOAD_TYPES.PDF
  const clientPriceRef = useRef(null)
  const [clientPrice, setClientPrice] = useState(
    downloadBudgetConfig[tipo][INPUTS.PDF_PRICE_OPTION],
  )

  const [companyAndCustomerInfo, setCompanyAndCustomerInfo] = useState(
    downloadBudgetConfig[tipo][INPUTS.COMPANY_AND_CLIENT_INFO],
  )

  const [generalConditions, setGeneralConditions] = useState(
    downloadBudgetConfig[tipo][INPUTS.GENERAL_CONDITIONS],
  )

  const [decomposition, setDecomposition] = useState(
    downloadBudgetConfig[tipo][INPUTS.PART_DECOMPOSITION],
  )

  const briefingPositionRef = useRef(null)
  const [briefingPosition, setBriefingPosition] = useState(
    downloadBudgetConfig[tipo][INPUTS.BRIEFING_POSITION],
  )

  const [addCover, setAddCover] = useState(
    downloadBudgetConfig[tipo][INPUTS.ADD_COVER],
  )

  const [addSignature, setAddSignature] = useState(
    downloadBudgetConfig[tipo][INPUTS.ADD_SIGNATURE],
  )

  const [addDate, setAddDate] = useState(
    downloadBudgetConfig[tipo][INPUTS.ADD_DATE],
  )

  const [pdfMeasurements, setPdfMeasurements] = useState(
    downloadBudgetConfig[tipo][INPUTS.PDF_MEASUREMENTS],
  )

  const [bordes, setBordes] = useState(
    downloadBudgetConfig[tipo][INPUTS.BORDES],
  )

  return {
    clientPrice,
    setClientPrice,
    clientPriceRef,
    companyAndCustomerInfo,
    setCompanyAndCustomerInfo,
    generalConditions,
    setGeneralConditions,
    decomposition,
    setDecomposition,
    briefingPosition,
    setBriefingPosition,
    briefingPositionRef,
    addCover,
    setAddCover,
    addSignature,
    setAddSignature,
    addDate,
    setAddDate,
    pdfMeasurements,
    setPdfMeasurements,
    bordes,
    setBordes,
  }
}
